import React, {useCallback, useEffect, useState} from 'react';
import {Handle, Position} from "react-flow-renderer";
import Select from 'react-select';
import RightClickMenu from "./Components/RightClickMenu";

const style = {
    outline: "2px solid orange",
}

const Random = ({data, id}) => {

    const [menu, showMenu] = useState(false)

    const [number, setNumber] = useState("1")

    const DisableActive = useCallback((event) => {

        setStl({})
        setActive(false)
        // document.getElementById( 'TextArea' ).scrollTop = 0
        showMenu(false)
    }, [])

    const [active, setActive] = useState(false)
    const [stl, setStl] = useState({})


    useEffect(() => {
        data.ActivFun = DisableActive
        data.active = onDoubleClick

        setNumber(String(data.number));
    }, [])

    const ChangeValue = useCallback((event) => {
        setNumber(event.target.value)
        data.number = Number(event.target.value)

    }, [])

    const onDoubleClick = useCallback((event) => {
        setActive(true)
        setStl(style)

    }, [])


    return (
        <div className="If-node"
             style={{...stl,}}
        >


            <Handle type="target" className="MainIne" position={Position.Left} id="in"/>
            <Handle type="source" className="MainOute" position={Position.Right} id="out"/>
            <div>
                <label>Random</label>

                <input
                    type="number"
                    min="1" max="10"

                    onChange={ChangeValue}

                    value={number}


                    style={{
                        margin: "0px",
                        background: "transparent",
                        outline: "0",
                        marginLeft: "5px",
                        padding: "0",
                        width: "40px",
                        height: "30px",
                        color: "white",
                        border: "0",
                        textAlign: "center",
                        fontSize: "1.1rem"

                    }}/>
            </div>
            {!active && <div
                onContextMenu={
                    event => {
                        event.preventDefault()
                        showMenu(!menu)
                    }
                }

                className="Shild"></div>}

            {menu && <RightClickMenu data={data} id={id}/>}
        </div>
    );
};

export default Random